import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetGuestSessionStateQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetGuestSessionStateQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    activeSession: {
      __typename?: 'EventSession';
      id: string;
      person?: { __typename?: 'Person'; id: string; fullName?: string | null; email?: string | null } | null;
      eventCTA: { __typename?: 'EventSessionCTA'; id: string; rsvpAttendanceStatus: Types.EventRSVPAttendanceStatus };
    };
  } | null;
};

export const GetGuestSessionStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGuestSessionState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'person' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'eventCTA' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rsvpAttendanceStatus' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGuestSessionStateQuery__
 *
 * To run a query within a React component, call `useGetGuestSessionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestSessionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestSessionStateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetGuestSessionStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestSessionStateQuery, GetGuestSessionStateQueryVariables>) {
  return ApolloReactHooks.useQuery<GetGuestSessionStateQuery, GetGuestSessionStateQueryVariables>(GetGuestSessionStateDocument, baseOptions);
}
export function useGetGuestSessionStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestSessionStateQuery, GetGuestSessionStateQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetGuestSessionStateQuery, GetGuestSessionStateQueryVariables>(GetGuestSessionStateDocument, baseOptions);
}
export type GetGuestSessionStateQueryHookResult = ReturnType<typeof useGetGuestSessionStateQuery>;
export type GetGuestSessionStateLazyQueryHookResult = ReturnType<typeof useGetGuestSessionStateLazyQuery>;
export type GetGuestSessionStateQueryResult = Apollo.QueryResult<GetGuestSessionStateQuery, GetGuestSessionStateQueryVariables>;
